import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const ArrowRight = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.026 12.0354C9.78658 12.2714 9.4011 12.2687 9.16505 12.0292C8.92899 11.7898 8.93174 11.4043 9.17118 11.1683L11.7674 8.60878H2.37603C2.03979 8.60878 1.76721 8.3362 1.76721 7.99996C1.76721 7.66372 2.03979 7.39114 2.37603 7.39114H11.751L9.16982 4.8304C8.93112 4.59359 8.92958 4.20811 9.16639 3.9694C9.4032 3.7307 9.78868 3.72917 10.0274 3.96598L13.5296 7.44037C13.8471 7.75542 13.8463 8.26913 13.5278 8.58318L10.026 12.0354Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default ArrowRight;
